import React from "react";
import Footer from "common/Footer";
import Navbar from "common/Navbar";
import { useAuth } from "context/AuthContext";
import "./layout.css";

const MainLayout = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return (
    <main className="grid-layout">
      {isAuthenticated && (
        <section className="header">
          <Navbar />
        </section>
      )}
      <section className="content">{children}</section>
      <section className="footer">
        <Footer />
      </section>
    </main>
  );
};

export default MainLayout;
